import {
  COMPLETED_PROFILE,
  tasksForSavingProductsToGA,
  tasksWithInternalLink,
} from '../../../constants/task'
import { useTranslation } from '../../../translations'
import { useQuestFlags } from './useQuestFlags'

export const useButtonAttribute = ({ quest }) => {
  const { t } = useTranslation()
  const { uid, isComplete, type, button_link, internal_link } = quest
  const { isBuyTask, isSubscribeTask, isFavouriteTask, isAddToCartTask } = useQuestFlags({ quest })

  return (() => {
    const customTypesLogic = [
      {
        cond: isComplete,
        props: { text: t('task.buttons.complete'), btnMod: 'complete' },
      },
      {
        cond: isBuyTask,
        props: ['BrandPricePurchase', 'PricePurchase', 'GachaCashPurchase'].includes(type)
          ? {
              btnMod: 'doTask',
              text: t('task.buttons.goToComplete'),
              tag: 'a',
              target: '_blank',
              href: button_link,
            }
          : { text: t('task.buttons.buy') },
      },
      {
        cond: isSubscribeTask,
        props: {
          btnMod: 'subscribe',
          text: type === 'ClickOnLink' ? t('task.buttons.go') : t('task.buttons.subscribe'),
          tag: 'a',
          target: '_blank',
          href: button_link,
        },
      },
      {
        cond: isFavouriteTask,
        props: {
          btnMod: 'addToFavorite',
          text: type === 'UsePublicPromocode' ? t('task.buttons.shopping') : t('task.buttons.go'),
          tag: 'a',
          target: '_blank',
          href: button_link,
        },
      },
      {
        cond: isAddToCartTask,
        props: { text: t('task.buttons.go') },
      },
      {
        cond: internal_link || button_link,
        props: (() => {
          if (internal_link) {
            const type = tasksForSavingProductsToGA[uid] ? 'add' : 'go'
            return { text: t(`task.buttons.${type}`), btnMod: 'tasksForSavingProducts' }
          }

          if (button_link) {
            if (uid === COMPLETED_PROFILE)
              return { text: t('task.buttons.fillProfile'), btnMod: 'fillProfile' }
          }

          return { text: t('task.buttons.default'), btnMod: 'btnDefault' }
        })(),
      },
    ]

    for (const { cond, props } of customTypesLogic) if (cond) return props
  })()
}
